module.exports = __webpack_public_path__ + "f6ea7f2a1cf152fdbaf40a618c661b3f.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/9/bits_pretzels_news_image.png
// module id = 250
// module chunks = 0